module.exports = __webpack_public_path__ + "img/bn.19a741e2.svg";